module.exports = __webpack_public_path__ + "img/album21_10.37b56f5b.jpg";